import ProviderCallback from './provider-callback';

export default ProviderCallback;
